var $ = Object.defineProperty;
var w = (o, a, t) => a in o ? $(o, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[a] = t;
var r = (o, a, t) => (w(o, typeof a != "symbol" ? a + "" : a, t), t);
const T = typeof process < "u" && process.versions != null && process.versions.node != null, S = () => {
  let o = window.location.href;
  return o.endsWith("/") && (o = o.slice(0, -1)), o;
}, G = T ? S() : "";
function g(o) {
  if (!T)
    return o;
  const a = o.toString();
  return `${G}${a}`;
}
class f extends Error {
  constructor(t) {
    super(t.statusText);
    r(this, "response");
    this.response = t, Object.setPrototypeOf(this, f.prototype);
  }
}
window.gleerupsApiFetch = window.gleerupsApiFetch ?? {
  observers: []
};
const F = (o) => {
  window.gleerupsApiFetch.observers.includes(o) || window.gleerupsApiFetch.observers.push(o);
}, I = (o) => {
  const a = window.gleerupsApiFetch.observers.indexOf(o);
  a !== -1 && window.gleerupsApiFetch.observers.splice(a, 1);
}, O = () => {
  window.gleerupsApiFetch.observers.forEach((o) => o());
}, b = (o, { onError: a, redirectOnUnauthorized: t = !0 } = {}) => {
  if (o.status >= 200 && o.status < 300)
    return o;
  if (o.status === 401 && t) {
    O(), console.info("Api responded with 401 Unauthorized, Redirecting to login!");
    const s = window.location.pathname.substring(1), i = encodeURIComponent(
      `${s}${window.location.search}${window.location.hash}`
    );
    window.location.href = `/login/?r=${i}`;
  }
  const e = new f(o);
  throw a && a({ statusCode: o.status, error: e }), e;
}, x = (o) => o.json(), A = async (o, a = {}) => {
  var l;
  const t = a.apiUrl ?? "", e = a.timeout ?? 1e4, s = g(t), i = o.replace(/^\//, ""), n = new AbortController(), { signal: c } = n, p = setTimeout(() => n.abort(), e), d = await fetch(`${s}/${i}`, {
    ...a,
    credentials: "include",
    signal: c
  });
  return clearTimeout(p), b(d, {
    onError: a.onError,
    redirectOnUnauthorized: !a.ignoreRedirect
  }), (l = d.headers.get("Content-Type")) != null && l.match("json") ? x(d) : d.text();
}, R = (o) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (a, t = {}) => A(a, { ...o, ...t })
);
var M = /* @__PURE__ */ ((o) => (o.Ar = "ar", o.Fa = "fa", o.En = "en", o.So = "so", o.Ti = "ti", o.Uk = "uk", o))(M || {}), D = /* @__PURE__ */ ((o) => (o.Json = "application/json", o.FormData = "multipart/form-data", o.UrlEncoded = "application/x-www-form-urlencoded", o.Text = "text/plain", o))(D || {});
class U {
  constructor(a = {}) {
    r(this, "baseUrl", "/api");
    r(this, "securityData", null);
    r(this, "securityWorker");
    r(this, "abortControllers", /* @__PURE__ */ new Map());
    r(this, "customFetch", (...a) => fetch(...a));
    r(this, "baseApiParams", {
      credentials: "same-origin",
      headers: {},
      redirect: "follow",
      referrerPolicy: "no-referrer"
    });
    r(this, "setSecurityData", (a) => {
      this.securityData = a;
    });
    r(this, "contentFormatters", {
      "application/json": (a) => a !== null && (typeof a == "object" || typeof a == "string") ? JSON.stringify(a) : a,
      "text/plain": (a) => a !== null && typeof a != "string" ? JSON.stringify(a) : a,
      "multipart/form-data": (a) => Object.keys(a || {}).reduce((t, e) => {
        const s = a[e];
        return t.append(
          e,
          s instanceof Blob ? s : typeof s == "object" && s !== null ? JSON.stringify(s) : `${s}`
        ), t;
      }, new FormData()),
      "application/x-www-form-urlencoded": (a) => this.toQueryString(a)
    });
    r(this, "createAbortSignal", (a) => {
      if (this.abortControllers.has(a)) {
        const e = this.abortControllers.get(a);
        return e ? e.signal : void 0;
      }
      const t = new AbortController();
      return this.abortControllers.set(a, t), t.signal;
    });
    r(this, "abortRequest", (a) => {
      const t = this.abortControllers.get(a);
      t && (t.abort(), this.abortControllers.delete(a));
    });
    r(this, "request", async ({
      body: a,
      secure: t,
      path: e,
      type: s,
      query: i,
      format: n,
      baseUrl: c,
      cancelToken: p,
      ...d
    }) => {
      const l = (typeof t == "boolean" ? t : this.baseApiParams.secure) && this.securityWorker && await this.securityWorker(this.securityData) || {}, u = this.mergeRequestParams(d, l), y = i && this.toQueryString(i), P = this.contentFormatters[
        s || "application/json"
        /* Json */
      ], E = n || u.format;
      return this.customFetch(`${c || this.baseUrl || ""}${e}${y ? `?${y}` : ""}`, {
        ...u,
        headers: {
          ...u.headers || {},
          ...s && s !== "multipart/form-data" ? { "Content-Type": s } : {}
        },
        signal: (p ? this.createAbortSignal(p) : u.signal) || null,
        body: typeof a > "u" || a === null ? null : P(a)
      }).then(async (j) => {
        const h = j;
        h.data = null, h.error = null;
        const q = E ? await j[E]().then((m) => (h.ok ? h.data = m : h.error = m, h)).catch((m) => (h.error = m, h)) : h;
        if (p && this.abortControllers.delete(p), !j.ok)
          throw q;
        return q;
      });
    });
    Object.assign(this, a);
  }
  encodeQueryParam(a, t) {
    return `${encodeURIComponent(a)}=${encodeURIComponent(typeof t == "number" ? t : `${t}`)}`;
  }
  addQueryParam(a, t) {
    return this.encodeQueryParam(t, a[t]);
  }
  addArrayQueryParam(a, t) {
    return a[t].map((s) => this.encodeQueryParam(t, s)).join("&");
  }
  toQueryString(a) {
    const t = a || {};
    return Object.keys(t).filter((s) => typeof t[s] < "u").map((s) => Array.isArray(t[s]) ? this.addArrayQueryParam(t, s) : this.addQueryParam(t, s)).join("&");
  }
  addQueryParams(a) {
    const t = this.toQueryString(a);
    return t ? `?${t}` : "";
  }
  mergeRequestParams(a, t) {
    return {
      ...this.baseApiParams,
      ...a,
      ...t || {},
      headers: {
        ...this.baseApiParams.headers || {},
        ...a.headers || {},
        ...t && t.headers || {}
      }
    };
  }
}
class k extends U {
  constructor() {
    super(...arguments);
    r(this, "addons", {
      /**
       * @description Creates an addon
       *
       * @tags addons
       * @name CreateAddon
       * @request POST:/addons
       */
      createAddon: (t, e = {}) => this.request({
        path: "/addons",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Returns a list of addons for an article
       *
       * @tags addons
       * @name GetAddonsForArticle
       * @request GET:/addons/article/{id}
       */
      getAddonsForArticle: (t, e = {}) => this.request({
        path: `/addons/article/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns a list of addons for an educational material
       *
       * @tags addons
       * @name GetAddonsForEducationalMaterial
       * @request GET:/addons/educational-material/{id}
       */
      getAddonsForEducationalMaterial: (t, e = {}) => this.request({
        path: `/addons/educational-material/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Share addon with group
       *
       * @tags addons
       * @name ShareAddonWithGroup
       * @request PUT:/addons/{addonId}/shares/groups/{groupId}
       */
      shareAddonWithGroup: (t, e, s, i = {}) => this.request({
        path: `/addons/${t}/shares/groups/${e}`,
        method: "PUT",
        body: s,
        type: "application/json",
        format: "json",
        ...i
      }),
      /**
       * @description Updates an addon
       *
       * @tags addons
       * @name EditAddon
       * @request PUT:/addons/{id}
       */
      editAddon: (t, e, s = {}) => this.request({
        path: `/addons/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Deletes an addon
       *
       * @tags addons
       * @name DeleteAddon
       * @request DELETE:/addons/{id}
       */
      deleteAddon: (t, e = {}) => this.request({
        path: `/addons/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Returns a list of who addon is shared with
       *
       * @tags addons
       * @name GetSharedAddons
       * @request GET:/addons/{id}/shares
       */
      getSharedAddons: (t, e = {}) => this.request({
        path: `/addons/${t}/shares`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "admin", {
      /**
       * @description Returns all educational materials
       *
       * @tags admin-educational-materials
       * @name GetEducationalMaterials
       * @request GET:/admin/books
       */
      getEducationalMaterials: (t = {}) => this.request({
        path: "/admin/books",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Creates an educational material
       *
       * @tags admin-educational-materials
       * @name CreateEducationalMaterial
       * @request POST:/admin/educational-materials/
       */
      createEducationalMaterial: (t, e = {}) => this.request({
        path: "/admin/educational-materials/",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Gets words linked to article or component
       *
       * @tags admin-educational-materials
       * @name GetLinkedWords
       * @request GET:/admin/educational-materials/{educationalMaterialId}/words
       */
      getLinkedWords: (t, e, s = {}) => this.request({
        path: `/admin/educational-materials/${t}/words`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Updates an educational material
       *
       * @tags admin-educational-materials
       * @name UpdateEducationalMaterial
       * @request PUT:/admin/educational-materials/{id}
       */
      updateEducationalMaterial: (t, e, s = {}) => this.request({
        path: `/admin/educational-materials/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Mark an educational material as deleted
       *
       * @tags admin-educational-materials
       * @name DeleteEducationalMaterial
       * @request DELETE:/admin/educational-materials/{id}
       */
      deleteEducationalMaterial: (t, e = {}) => this.request({
        path: `/admin/educational-materials/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Updates an article, book structure and components
       *
       * @tags admin-educational-materials
       * @name UpdatePageView
       * @request POST:/admin/educational-materials/{id}/page-view/
       */
      updatePageView: (t, e, s = {}) => this.request({
        path: `/admin/educational-materials/${t}/page-view/`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Updates structure for an educational material
       *
       * @tags admin-educational-materials
       * @name BatchUpdate
       * @request POST:/admin/educational-materials/{slug}/batch-update/
       */
      batchUpdate: (t, e, s = {}) => this.request({
        path: `/admin/educational-materials/${t}/batch-update/`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Returns a list of files for the supplied directory
       *
       * @tags admin-educational-materials
       * @name GetFiles
       * @request GET:/admin/files/{path}
       */
      getFiles: (t, e = {}) => this.request({
        path: `/admin/files/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns a list of common icons and book icons
       *
       * @tags admin-educational-materials
       * @name GetIcons
       * @request GET:/admin/icons/{bookId}
       */
      getIcons: (t, e = {}) => this.request({
        path: `/admin/icons/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Updates an educational material
       *
       * @tags admin-educational-materials
       * @name UpdateEducationalMaterialPublishedState
       * @request PUT:/admin/publish/educational-materials/{id}
       */
      updateEducationalMaterialPublishedState: (t, e, s = {}) => this.request({
        path: `/admin/publish/educational-materials/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...s
      }),
      /**
       * @description Returns search results with articles and media educational material
       *
       * @tags admin-educational-materials
       * @name AdminSearchEducationalMaterial
       * @request GET:/admin/search/educational-materials/{educationalMaterialId}
       */
      adminSearchEducationalMaterial: (t, e, s = {}) => this.request({
        path: `/admin/search/educational-materials/${t}`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Search and replace words in a component
       *
       * @tags admin-educational-materials
       * @name SearchReplaceWords
       * @request POST:/admin/search/educational-materials/{educationalMaterialId}/articles/{articleId}/
       */
      searchReplaceWords: (t, e, s, i = {}) => this.request({
        path: `/admin/search/educational-materials/${t}/articles/${e}/`,
        method: "POST",
        body: s,
        type: "application/json",
        ...i
      }),
      /**
       * @description Search slide shows
       *
       * @tags admin-slide-shows
       * @name SearchSlideShows
       * @request GET:/admin/slide-shows/
       */
      searchSlideShows: (t, e = {}) => this.request({
        path: "/admin/slide-shows/",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Creates a slide show
       *
       * @tags admin-slide-shows
       * @name CreateSlideShow
       * @request POST:/admin/slide-shows/
       */
      createSlideShow: (t, e = {}) => this.request({
        path: "/admin/slide-shows/",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Checks copyright info in exif
       *
       * @tags admin-slide-shows
       * @name SlideShowImageCopyRight
       * @request PUT:/admin/slide-shows/images/copyright
       */
      slideShowImageCopyRight: (t, e = {}) => this.request({
        path: "/admin/slide-shows/images/copyright",
        method: "PUT",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      }),
      /**
       * @description List all slide show authors
       *
       * @tags admin-slide-shows
       * @name GetSlideShowAuthors
       * @request GET:/admin/slide-shows/users
       */
      getSlideShowAuthors: (t = {}) => this.request({
        path: "/admin/slide-shows/users",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Gets a slide show
       *
       * @tags admin-slide-shows
       * @name GetSlideShow
       * @request GET:/admin/slide-shows/{slideShowId}
       */
      getSlideShow: (t, e = {}) => this.request({
        path: `/admin/slide-shows/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Update a slide show
       *
       * @tags admin-slide-shows
       * @name UpdateSlideShow
       * @request PUT:/admin/slide-shows/{slideShowId}
       */
      updateSlideShow: (t, e, s = {}) => this.request({
        path: `/admin/slide-shows/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Copy a slide show
       *
       * @tags admin-slide-shows
       * @name CopySlideShow
       * @request POST:/admin/slide-shows/{slideShowId}
       */
      copySlideShow: (t, e, s = {}) => this.request({
        path: `/admin/slide-shows/${t}`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Deletes a slide show
       *
       * @tags admin-slide-shows
       * @name DeleteSlideShow
       * @request DELETE:/admin/slide-shows/{slideShowId}
       */
      deleteSlideShow: (t, e = {}) => this.request({
        path: `/admin/slide-shows/${t}`,
        method: "DELETE",
        ...e
      }),
      /**
       * @description Uploads image for slide show
       *
       * @tags admin-slide-shows
       * @name UploadSlideShowImage
       * @request POST:/admin/slide-shows/{slideShowId}/images
       */
      uploadSlideShowImage: (t, e, s = {}) => this.request({
        path: `/admin/slide-shows/${t}/images`,
        method: "POST",
        body: e,
        type: "multipart/form-data",
        format: "json",
        ...s
      }),
      /**
       * @description Deletes an image from a slide show
       *
       * @tags admin-slide-shows
       * @name DeleteSlideShowImage
       * @request DELETE:/admin/slide-shows/{slideShowId}/images/{imageId}
       */
      deleteSlideShowImage: (t, e, s = {}) => this.request({
        path: `/admin/slide-shows/${t}/images/${e}`,
        method: "DELETE",
        format: "json",
        ...s
      })
    });
    r(this, "books", {
      /**
       * @description Returns all educational materials
       *
       * @tags books
       * @name GetEducationalMaterialsLegacy
       * @request GET:/books
       */
      getEducationalMaterialsLegacy: (t = {}) => this.request({
        path: "/books",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns a book
       *
       * @tags books
       * @name GetBook
       * @request GET:/books/{slug}
       */
      getBook: (t, e = {}) => this.request({
        path: `/books/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "educationalMaterialGroups", {
      /**
       * @description Returns a lists of all educational material groups
       *
       * @tags educational-material-groups
       * @name GetEducationalMaterialGroups
       * @request GET:/educational-material-groups
       */
      getEducationalMaterialGroups: (t = {}) => this.request({
        path: "/educational-material-groups",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Creates an educational material group
       *
       * @tags educational-material-groups
       * @name CreateEducationalMaterialGroup
       * @request POST:/educational-material-groups
       */
      createEducationalMaterialGroup: (t, e = {}) => this.request({
        path: "/educational-material-groups",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Checks if supplied image is valid to be used for educational material groups given the file type, size and dimensions
       *
       * @tags educational-material-groups
       * @name ValidateEducationalMaterialGroupImage
       * @request POST:/educational-material-groups/image/validate
       */
      validateEducationalMaterialGroupImage: (t, e = {}) => this.request({
        path: "/educational-material-groups/image/validate",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      }),
      /**
       * @description Returns an educational material group with details
       *
       * @tags educational-material-groups
       * @name GetEducationalMaterialGroupDetails
       * @request GET:/educational-material-groups/{id}
       */
      getEducationalMaterialGroupDetails: (t, e = {}) => this.request({
        path: `/educational-material-groups/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Updates an educational material group
       *
       * @tags educational-material-groups
       * @name EditEducationalMaterialGroup
       * @request PUT:/educational-material-groups/{id}
       */
      editEducationalMaterialGroup: (t, e, s = {}) => this.request({
        path: `/educational-material-groups/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Deletes an educational material group
       *
       * @tags educational-material-groups
       * @name DeleteEducationalMaterialGroup
       * @request DELETE:/educational-material-groups/{id}
       */
      deleteEducationalMaterialGroup: (t, e = {}) => this.request({
        path: `/educational-material-groups/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Uploads an image from supplied file for the educational material group
       *
       * @tags educational-material-groups
       * @name UploadEducationalMaterialGroupImage
       * @request POST:/educational-material-groups/{id}/image
       */
      uploadEducationalMaterialGroupImage: (t, e, s = {}) => this.request({
        path: `/educational-material-groups/${t}/image`,
        method: "POST",
        body: e,
        type: "multipart/form-data",
        format: "json",
        ...s
      })
    });
    r(this, "educationalMaterial", {
      /**
       * @description Gets mapping structure for educational material
       *
       * @tags language-support
       * @name GetIltMappingStructure
       * @request GET:/educational-material/{id}/language-support
       */
      getIltMappingStructure: (t, e = {}) => this.request({
        path: `/educational-material/${t}/language-support`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "educationalMaterialsPartial", {
      /**
       * @description Returns all educational materials with partial data
       *
       * @tags educational-materials
       * @name GetPartialEducationalMaterials
       * @request GET:/educational-materials-partial/
       */
      getPartialEducationalMaterials: (t = {}) => this.request({
        path: "/educational-materials-partial/",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns educational materials with partial data
       *
       * @tags educational-materials
       * @name GetPartialEducationalMaterialById
       * @request GET:/educational-materials-partial/{id}
       */
      getPartialEducationalMaterialById: (t, e = {}) => this.request({
        path: `/educational-materials-partial/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "educationalMaterials", {
      /**
       * @description Return a tree-view with chapter articles and words
       *
       * @tags word
       * @name GetChapterWords
       * @request GET:/educational-materials/{id}/chapter-words/
       */
      getChapterWords: (t, e = {}) => this.request({
        path: `/educational-materials/${t}/chapter-words/`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Gets a educational material group if educational material id is a group
       *
       * @tags educational-material-groups
       * @name GetEducationalMaterialGroupDetailsByEmId
       * @request GET:/educational-materials/{id}/educational-material-groups
       */
      getEducationalMaterialGroupDetailsByEmId: (t, e = {}) => this.request({
        path: `/educational-materials/${t}/educational-material-groups`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns a license info for educational material
       *
       * @tags educational-materials
       * @name GetEducationalMaterialLicense
       * @request GET:/educational-materials/{id}/licenses
       */
      getEducationalMaterialLicense: (t, e = {}) => this.request({
        path: `/educational-materials/${t}/licenses`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description lists word lists
       *
       * @tags word-lists
       * @name GetWordLists
       * @request GET:/educational-materials/{id}/word-lists/
       */
      getWordLists: (t, e, s = {}) => this.request({
        path: `/educational-materials/${t}/word-lists/`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Copy multiple word lists
       *
       * @tags word-lists
       * @name CopyMultipleWordLists
       * @request POST:/educational-materials/{id}/word-lists/
       */
      copyMultipleWordLists: (t, e, s = {}) => this.request({
        path: `/educational-materials/${t}/word-lists/`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description get warning if word lists are used in articles
       *
       * @tags word-lists
       * @name DeleteWarning
       * @request GET:/educational-materials/{id}/word-lists/delete-warning
       */
      deleteWarning: (t, e, s = {}) => this.request({
        path: `/educational-materials/${t}/word-lists/delete-warning`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Copy multiple words
       *
       * @tags word
       * @name CopyWords
       * @request POST:/educational-materials/{id}/words
       */
      copyWords: (t, e, s = {}) => this.request({
        path: `/educational-materials/${t}/words`,
        method: "POST",
        body: e,
        type: "application/json",
        ...s
      }),
      /**
       * @description Import words with excel file
       *
       * @tags word
       * @name FileImport
       * @request POST:/educational-materials/{id}/words/file
       */
      fileImport: (t, e, s = {}) => this.request({
        path: `/educational-materials/${t}/words/file`,
        method: "POST",
        body: e,
        type: "multipart/form-data",
        ...s
      }),
      /**
       * @description Returns an educational material
       *
       * @tags educational-materials
       * @name GetEducationalMaterialBySlugOrId
       * @request GET:/educational-materials/{slugOrId}
       */
      getEducationalMaterialBySlugOrId: (t, e = {}) => this.request({
        path: `/educational-materials/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Get page view
       *
       * @tags educational-materials
       * @name GetPageView
       * @request GET:/educational-materials/{slugOrId}/page-view/{articleId}
       */
      getPageView: (t, e, s = {}) => this.request({
        path: `/educational-materials/${t}/page-view/${e}`,
        method: "GET",
        format: "json",
        ...s
      }),
      /**
       * @description Returns an educational material
       *
       * @tags educational-materials
       * @name GetEducationalMaterialForTeacher
       * @request GET:/educational-materials/{slugOrId}/teacher
       */
      getEducationalMaterialForTeacher: (t, e = {}) => this.request({
        path: `/educational-materials/${t}/teacher`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "exercises", {
      /**
       * @description upsert exercise
       *
       * @tags exercises
       * @name UpsertExercise
       * @request PUT:/exercises/
       */
      upsertExercise: (t, e = {}) => this.request({
        path: "/exercises/",
        method: "PUT",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Delete exercises by ids
       *
       * @tags exercises
       * @name DeleteExercises
       * @request DELETE:/exercises/
       */
      deleteExercises: (t, e = {}) => this.request({
        path: "/exercises/",
        method: "DELETE",
        body: t,
        type: "application/json",
        ...e
      }),
      /**
       * @description Copy exercises to educationalMaterial
       *
       * @tags exercises
       * @name CopyExercises
       * @request POST:/exercises/copy
       */
      copyExercises: (t, e = {}) => this.request({
        path: "/exercises/copy",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      /**
       * @description Returns datafiles to be used in dropdown menues
       *
       * @tags exercises
       * @name GetDataFiles
       * @request GET:/exercises/data-files
       */
      getDataFiles: (t = {}) => this.request({
        path: "/exercises/data-files",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Upload a datafile to the public bucket
       *
       * @tags exercises
       * @name UploadDataFile
       * @request POST:/exercises/data-files
       */
      uploadDataFile: (t, e = {}) => this.request({
        path: "/exercises/data-files",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        ...e
      }),
      /**
       * @description Delete a datafile in the public bucket
       *
       * @tags exercises
       * @name DeleteDataFile
       * @request DELETE:/exercises/data-files/{fileName}
       */
      deleteDataFile: (t, e = {}) => this.request({
        path: `/exercises/data-files/${t}`,
        method: "DELETE",
        ...e
      }),
      /**
       * @description Returns a list of exercises in given educational material
       *
       * @tags exercises
       * @name GetExercises
       * @request GET:/exercises/search/{educationalMaterialId}
       */
      getExercises: (t, e, s = {}) => this.request({
        path: `/exercises/search/${t}`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Get user access to educational materials
       *
       * @tags exercises
       * @name GetUserAccessToEducationalMaterials
       * @request GET:/exercises/users/{userId}/access
       */
      getUserAccessToEducationalMaterials: (t, e = {}) => this.request({
        path: `/exercises/users/${t}/access`,
        method: "GET",
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Set user access to educational materials
       *
       * @tags exercises
       * @name SetUserAccessToEducationalMaterials
       * @request POST:/exercises/users/{userId}/access
       */
      setUserAccessToEducationalMaterials: (t, e, s = {}) => this.request({
        path: `/exercises/users/${t}/access`,
        method: "POST",
        body: e,
        type: "application/json",
        ...s
      }),
      /**
       * @description Get exercise authors
       *
       * @tags exercises
       * @name GetExerciseAuthors
       * @request GET:/exercises/{educationalMaterialId}/authors
       */
      getExerciseAuthors: (t, e = {}) => this.request({
        path: `/exercises/${t}/authors`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Remove question from exercise
       *
       * @tags exercises
       * @name RemoveQuestionFromExercise
       * @request DELETE:/exercises/{exerciseId}/questions/{questionId}
       */
      removeQuestionFromExercise: (t, e, s = {}) => this.request({
        path: `/exercises/${t}/questions/${e}`,
        method: "DELETE",
        ...s
      }),
      /**
       * @description Get exercise by id
       *
       * @tags exercises
       * @name GetExercise
       * @request GET:/exercises/{id}
       */
      getExercise: (t, e = {}) => this.request({
        path: `/exercises/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "languageSupport", {
      /**
       * @description Returns language support settings for user
       *
       * @tags language-support
       * @name GetSettings
       * @request GET:/language-support/settings
       */
      getSettings: (t = {}) => this.request({
        path: "/language-support/settings",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Upserts language support settings for user
       *
       * @tags language-support
       * @name UpsertSettings
       * @request PUT:/language-support/settings
       */
      upsertSettings: (t, e = {}) => this.request({
        path: "/language-support/settings",
        method: "PUT",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Delete language support settings for user
       *
       * @tags language-support
       * @name DeleteSettings
       * @request DELETE:/language-support/settings
       */
      deleteSettings: (t = {}) => this.request({
        path: "/language-support/settings",
        method: "DELETE",
        type: "application/json",
        ...t
      })
    });
    r(this, "maintenanceInfo", {
      /**
       * @description Updates current maintenance info
       *
       * @tags maintenance-info
       * @name UpdateMaintenanceInfo
       * @request POST:/maintenance-info
       */
      updateMaintenanceInfo: (t, e = {}) => this.request({
        path: "/maintenance-info",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Cancels current maintenance info
       *
       * @tags maintenance-info
       * @name CancelMaintenanceInfo
       * @request DELETE:/maintenance-info
       */
      cancelMaintenanceInfo: (t = {}) => this.request({
        path: "/maintenance-info",
        method: "DELETE",
        type: "application/json",
        ...t
      })
    });
    r(this, "marketing", {
      /**
       * @description Returns a list of news
       *
       * @tags marketing
       * @name GetNews
       * @request GET:/marketing/news
       */
      getNews: (t = {}) => this.request({
        path: "/marketing/news",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Creates a news article
       *
       * @tags marketing
       * @name CreateNews
       * @request POST:/marketing/news
       */
      createNews: (t, e = {}) => this.request({
        path: "/marketing/news",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Checks if supplied image is valid to be used for news given the file type, size and dimensions
       *
       * @tags marketing
       * @name ValidateImage
       * @request POST:/marketing/news/image
       */
      validateImage: (t, e = {}) => this.request({
        path: "/marketing/news/image",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      }),
      /**
       * @description Returns news by id
       *
       * @tags marketing
       * @name GetNewsById
       * @request GET:/marketing/news/{id}
       */
      getNewsById: (t, e = {}) => this.request({
        path: `/marketing/news/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Edits a news article
       *
       * @tags marketing
       * @name EditNews
       * @request PUT:/marketing/news/{id}
       */
      editNews: (t, e, s = {}) => this.request({
        path: `/marketing/news/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Deletes news
       *
       * @tags marketing
       * @name DeleteNews
       * @request DELETE:/marketing/news/{id}
       */
      deleteNews: (t, e = {}) => this.request({
        path: `/marketing/news/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Uploads an image from supplied file for the news
       *
       * @tags marketing
       * @name UploadImage
       * @request POST:/marketing/news/{id}/image
       */
      uploadImage: (t, e, s = {}) => this.request({
        path: `/marketing/news/${t}/image`,
        method: "POST",
        body: e,
        type: "multipart/form-data",
        format: "json",
        ...s
      })
    });
    r(this, "markings", {
      /**
       * @description Returns a list of markings for an educational material
       *
       * @tags markings
       * @name GetMarkingsForEducationalMaterial
       * @request GET:/markings
       */
      getMarkingsForEducationalMaterial: (t, e = {}) => this.request({
        path: "/markings",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Creates a marking for an educational material
       *
       * @tags markings
       * @name CreateMarkingForEducationalMaterial
       * @request POST:/markings
       */
      createMarkingForEducationalMaterial: (t, e = {}) => this.request({
        path: "/markings",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Delete a marking
       *
       * @tags markings
       * @name DeleteMarking
       * @request DELETE:/markings/{id}
       */
      deleteMarking: (t, e = {}) => this.request({
        path: `/markings/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Update a marking
       *
       * @tags markings
       * @name UpdateMarking
       * @request PATCH:/markings/{id}
       */
      updateMarking: (t, e, s = {}) => this.request({
        path: `/markings/${t}`,
        method: "PATCH",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      })
    });
    r(this, "me", {
      /**
       * @description Returns info on current user
       *
       * @tags me
       * @name GetMe
       * @request GET:/me/
       */
      getMe: (t = {}) => this.request({
        path: "/me/",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns schools the current user can access
       *
       * @tags me
       * @name GetSchools
       * @request GET:/me/schools
       */
      getSchools: (t = {}) => this.request({
        path: "/me/schools",
        method: "GET",
        format: "json",
        ...t
      })
    });
    r(this, "notes", {
      /**
       * @description Returns a list of notes for educational material
       *
       * @tags notes
       * @name GetNotes
       * @request GET:/notes/
       */
      getNotes: (t, e = {}) => this.request({
        path: "/notes/",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Creates a note for educational material
       *
       * @tags notes
       * @name CreateNote
       * @request POST:/notes/
       */
      createNote: (t, e = {}) => this.request({
        path: "/notes/",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Edits note
       *
       * @tags notes
       * @name EditNote
       * @request PUT:/notes/{id}
       */
      editNote: (t, e, s = {}) => this.request({
        path: `/notes/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Deletes a note
       *
       * @tags notes
       * @name DeleteNote
       * @request DELETE:/notes/{id}
       */
      deleteNote: (t, e = {}) => this.request({
        path: `/notes/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      })
    });
    r(this, "notifications", {
      /**
       * @description Returns notifications for user
       *
       * @tags notifications
       * @name GetNotifications
       * @request GET:/notifications
       */
      getNotifications: (t = {}) => this.request({
        path: "/notifications",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Mark as read
       *
       * @tags notifications
       * @name MarkAsRead
       * @request PUT:/notifications/{id}
       */
      markAsRead: (t, e = {}) => this.request({
        path: `/notifications/${t}`,
        method: "PUT",
        type: "application/json",
        ...e
      }),
      /**
       * @description Delete a notification
       *
       * @tags notifications
       * @name DeleteNotification
       * @request DELETE:/notifications/{id}
       */
      deleteNotification: (t, e = {}) => this.request({
        path: `/notifications/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      })
    });
    r(this, "planDirectories", {
      /**
       * @description Returns a list of plan directories for the logged in user
       *
       * @tags plan-directories
       * @name GetPlanDirectories
       * @request GET:/plan-directories
       */
      getPlanDirectories: (t = {}) => this.request({
        path: "/plan-directories",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Creates a plan directory
       *
       * @tags plan-directories
       * @name CreatePlanDirectory
       * @request POST:/plan-directories
       */
      createPlanDirectory: (t, e = {}) => this.request({
        path: "/plan-directories",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Returns a plan directory for the logged in user
       *
       * @tags plan-directories
       * @name GetPlanDirectoryById
       * @request GET:/plan-directories/{id}
       */
      getPlanDirectoryById: (t, e = {}) => this.request({
        path: `/plan-directories/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Updates a plan directory
       *
       * @tags plan-directories
       * @name UpdatePlanDirectory
       * @request PUT:/plan-directories/{id}
       */
      updatePlanDirectory: (t, e, s = {}) => this.request({
        path: `/plan-directories/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...s
      }),
      /**
       * @description Deletes a plan directory
       *
       * @tags plan-directories
       * @name DeletePlanDirectory
       * @request DELETE:/plan-directories/{id}
       */
      deletePlanDirectory: (t, e = {}) => this.request({
        path: `/plan-directories/${t}`,
        method: "DELETE",
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Add a plan to plan directory
       *
       * @tags plan-directories
       * @name AddPlanToPlanDirectory
       * @request POST:/plan-directories/{planDirectoryId}/plans/{planId}
       */
      addPlanToPlanDirectory: (t, e, s = {}) => this.request({
        path: `/plan-directories/${t}/plans/${e}`,
        method: "POST",
        type: "application/json",
        ...s
      }),
      /**
       * @description Removes a plan from plan directory
       *
       * @tags plan-directories
       * @name RemovePlanFromPlanDirectory
       * @request DELETE:/plan-directories/{planDirectoryId}/plans/{planId}
       */
      removePlanFromPlanDirectory: (t, e, s = {}) => this.request({
        path: `/plan-directories/${t}/plans/${e}`,
        method: "DELETE",
        type: "application/json",
        ...s
      })
    });
    r(this, "plans", {
      /**
       * @description Returns a list of plans for the logged in user
       *
       * @tags plans
       * @name GetPlans
       * @request GET:/plans
       */
      getPlans: (t = {}) => this.request({
        path: "/plans",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Creates a plan
       *
       * @tags plans
       * @name CreatePlan
       * @request POST:/plans
       */
      createPlan: (t, e = {}) => this.request({
        path: "/plans",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Marks a plan block link as done for user
       *
       * @tags plans
       * @name CreatePlanBlockLinkProgress
       * @request POST:/plans/mark-as-done/{planBlockLinkId}
       */
      createPlanBlockLinkProgress: (t, e = {}) => this.request({
        path: `/plans/mark-as-done/${t}`,
        method: "POST",
        type: "application/json",
        ...e
      }),
      /**
       * @description Undo plan block link as done for user
       *
       * @tags plans
       * @name DeletePlanBlockLinkProgress
       * @request DELETE:/plans/mark-as-done/{planBlockLinkId}
       */
      deletePlanBlockLinkProgress: (t, e = {}) => this.request({
        path: `/plans/mark-as-done/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Lists sample plans
       *
       * @tags plans
       * @name GetSamplePlans
       * @request GET:/plans/samples
       */
      getSamplePlans: (t = {}) => this.request({
        path: "/plans/samples",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns a plan with details (such as directory) for the logged in user
       *
       * @tags plans
       * @name GetPlan
       * @request GET:/plans/{id}
       */
      getPlan: (t, e = {}) => this.request({
        path: `/plans/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Edits a plan
       *
       * @tags plans
       * @name EditPlan
       * @request PUT:/plans/{id}
       */
      editPlan: (t, e, s = {}) => this.request({
        path: `/plans/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...s
      }),
      /**
       * @description Returns a list of plans for the logged in user
       *
       * @tags plans
       * @name DeletePlan
       * @request DELETE:/plans/{id}
       */
      deletePlan: (t, e = {}) => this.request({
        path: `/plans/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Copy a plan
       *
       * @tags plans
       * @name CopyPlan
       * @request POST:/plans/{id}/copy
       */
      copyPlan: (t, e, s = {}) => this.request({
        path: `/plans/${t}/copy`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Hides a plan
       *
       * @tags plans
       * @name HidePlan
       * @request POST:/plans/{id}/hide
       */
      hidePlan: (t, e = {}) => this.request({
        path: `/plans/${t}/hide`,
        method: "POST",
        type: "application/json",
        ...e
      }),
      /**
       * @description Unhides a plan
       *
       * @tags plans
       * @name UnHidePlan
       * @request POST:/plans/{id}/unhide
       */
      unHidePlan: (t, e = {}) => this.request({
        path: `/plans/${t}/unhide`,
        method: "POST",
        type: "application/json",
        ...e
      }),
      /**
       * @description Creates a plan block
       *
       * @tags planblocks
       * @name CreatePlanBlock
       * @request POST:/plans/{planId}/blocks
       */
      createPlanBlock: (t, e, s = {}) => this.request({
        path: `/plans/${t}/blocks`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Edits a plan block
       *
       * @tags planblocks
       * @name UpdatePlanBlock
       * @request PUT:/plans/{planId}/blocks/{blockId}
       */
      updatePlanBlock: (t, e, s, i = {}) => this.request({
        path: `/plans/${t}/blocks/${e}`,
        method: "PUT",
        body: s,
        type: "application/json",
        format: "json",
        ...i
      }),
      /**
       * @description Deletes a plan block
       *
       * @tags planblocks
       * @name DeletePlanBlock
       * @request DELETE:/plans/{planId}/blocks/{blockId}
       */
      deletePlanBlock: (t, e, s = {}) => this.request({
        path: `/plans/${t}/blocks/${e}`,
        method: "DELETE",
        type: "application/json",
        ...s
      }),
      /**
       * @description List editors and owner for plan
       *
       * @tags plans
       * @name GetPlanEditors
       * @request GET:/plans/{planId}/editors
       */
      getPlanEditors: (t, e = {}) => this.request({
        path: `/plans/${t}/editors`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Invite users to edit plan
       *
       * @tags plans
       * @name AddPlanEditor
       * @request POST:/plans/{planId}/editors
       */
      addPlanEditor: (t, e, s = {}) => this.request({
        path: `/plans/${t}/editors`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Remove users from edit plan
       *
       * @tags plans
       * @name RemovePlanEditor
       * @request DELETE:/plans/{planId}/editors
       */
      removePlanEditor: (t, e, s = {}) => this.request({
        path: `/plans/${t}/editors`,
        method: "DELETE",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Get progress for groups.
       *
       * @tags plans
       * @name GetPlanProgress
       * @request GET:/plans/{planId}/progress
       */
      getPlanProgress: (t, e = {}) => this.request({
        path: `/plans/${t}/progress`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Get group shares for a plan
       *
       * @tags plans
       * @name GetSharesForPlan
       * @request GET:/plans/{planId}/shares
       */
      getSharesForPlan: (t, e = {}) => this.request({
        path: `/plans/${t}/shares`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Share a plan with a group or individual group members
       *
       * @tags plans
       * @name SharePlan
       * @request PUT:/plans/{planId}/shares/groups/{groupId}
       */
      sharePlan: (t, e, s, i = {}) => this.request({
        path: `/plans/${t}/shares/groups/${e}`,
        method: "PUT",
        body: s,
        type: "application/json",
        format: "json",
        ...i
      }),
      /**
       * @description Unshare a plan with a group (or members of it)
       *
       * @tags plans
       * @name UnsharePlan
       * @request DELETE:/plans/{planId}/shares/groups/{groupId}
       */
      unsharePlan: (t, e, s = {}) => this.request({
        path: `/plans/${t}/shares/groups/${e}`,
        method: "DELETE",
        type: "application/json",
        ...s
      })
    });
    r(this, "products", {
      /**
       * @description Returns a list of products licensed to the user
       *
       * @tags products
       * @name GetProducts
       * @request GET:/products/
       */
      getProducts: (t, e = {}) => this.request({
        path: "/products/",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Flush products cache for user
       *
       * @tags products
       * @name FlushProductsCache
       * @request DELETE:/products/cache/
       */
      flushProductsCache: (t = {}) => this.request({
        path: "/products/cache/",
        method: "DELETE",
        type: "application/json",
        ...t
      })
    });
    r(this, "publicArticles", {
      /**
       * @description List public articles
       *
       * @tags public-articles
       * @name ListPublicArticles
       * @request GET:/public-articles/
       */
      listPublicArticles: (t, e = {}) => this.request({
        path: "/public-articles/",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Publish an article
       *
       * @tags public-articles
       * @name PublishPublicArticle
       * @request POST:/public-articles/
       */
      publishPublicArticle: (t, e = {}) => this.request({
        path: "/public-articles/",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Get a public article by ID
       *
       * @tags public-articles
       * @name GetPublicArticle
       * @request GET:/public-articles/{id}
       */
      getPublicArticle: (t, e = {}) => this.request({
        path: `/public-articles/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Edits a public article
       *
       * @tags public-articles
       * @name EditPublicArticle
       * @request PUT:/public-articles/{id}
       */
      editPublicArticle: (t, e, s = {}) => this.request({
        path: `/public-articles/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Unpublish a public article
       *
       * @tags public-articles
       * @name UnpublishPublicArticle
       * @request DELETE:/public-articles/{id}
       */
      unpublishPublicArticle: (t, e = {}) => this.request({
        path: `/public-articles/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      })
    });
    r(this, "public", {
      /**
       * @description Returns a preview of the educational material
       *
       * @tags public
       * @name GetArticlePreview
       * @request GET:/public/educational-materials/{educationalMaterialIdOrSlug}/articles/{articleId}/preview/
       */
      getArticlePreview: (t, e, s = {}) => this.request({
        path: `/public/educational-materials/${t}/articles/${e}/preview/`,
        method: "GET",
        format: "json",
        ...s
      }),
      /**
       * @description Returns a list of all educational stages
       *
       * @tags public
       * @name GetEducationalStages
       * @request GET:/public/educational-stages
       */
      getEducationalStages: (t, e = {}) => this.request({
        path: "/public/educational-stages",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Returns a list of all grades
       *
       * @tags public
       * @name GetGrades
       * @request GET:/public/grades
       */
      getGrades: (t = {}) => this.request({
        path: "/public/grades",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Container health check for AWS ECS
       *
       * @tags public
       * @name Healthcheck
       * @request GET:/public/healthcheck
       */
      healthcheck: (t = {}) => this.request({
        path: "/public/healthcheck",
        method: "GET",
        ...t
      }),
      /**
       * @description Returns ILT token
       *
       * @tags public
       * @name AuthorizeIlt
       * @request POST:/public/ilt/authorize
       */
      authorizeIlt: (t = {}) => this.request({
        path: "/public/ilt/authorize",
        method: "POST",
        type: "application/json",
        format: "json",
        ...t
      }),
      /**
       * @description Returns current maintenance info
       *
       * @tags public
       * @name GetMaintenanceInfo
       * @request GET:/public/maintenance-info
       */
      getMaintenanceInfo: (t = {}) => this.request({
        path: "/public/maintenance-info",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns a plan preview
       *
       * @tags public
       * @name PreviewPlan
       * @request GET:/public/plans/{id}/preview
       */
      previewPlan: (t, e = {}) => this.request({
        path: `/public/plans/${t}/preview`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns list of trial products
       *
       * @tags public
       * @name GetPublicTrialProducts
       * @request GET:/public/products
       */
      getPublicTrialProducts: (t = {}) => this.request({
        path: "/public/products",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns a product
       *
       * @tags public
       * @name GetProduct
       * @request GET:/public/products/{id}
       */
      getProduct: (t, e = {}) => this.request({
        path: `/public/products/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Get public article view
       *
       * @tags public
       * @name GetPublicArticleView
       * @request GET:/public/public-articles/{id}
       */
      getPublicArticleView: (t, e = {}) => this.request({
        path: `/public/public-articles/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns if school is a skolon customer
       *
       * @tags public
       * @name GetIsCustomer
       * @request GET:/public/skolon/iscustomer/{id}
       */
      getIsCustomer: (t, e, s = {}) => this.request({
        path: `/public/skolon/iscustomer/${t}`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Returns a list of all subjects
       *
       * @tags public
       * @name GetSubjects
       * @request GET:/public/subjects
       */
      getSubjects: (t = {}) => this.request({
        path: "/public/subjects",
        method: "GET",
        format: "json",
        ...t
      })
    });
    r(this, "questbox", {
      /**
       * @description Adds a draft
       *
       * @tags questbox
       * @name AddDraftLegacy
       * @request POST:/questbox/drafts
       */
      addDraftLegacy: (t, e = {}) => this.request({
        path: "/questbox/drafts",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Returns an exercise with id
       *
       * @tags questbox
       * @name GetExerciseLegacy
       * @request GET:/questbox/exercises
       */
      getExerciseLegacy: (t, e = {}) => this.request({
        path: "/questbox/exercises",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Upload an image
       *
       * @tags questbox
       * @name UploadImageQuestboxLegacy
       * @request POST:/questbox/images
       */
      uploadImageQuestboxLegacy: (t, e = {}) => this.request({
        path: "/questbox/images",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      }),
      /**
       * @description Creates a response
       *
       * @tags questbox
       * @name CreateResponseLegacy
       * @request POST:/questbox/responses
       */
      createResponseLegacy: (t, e = {}) => this.request({
        path: "/questbox/responses",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "questions", {
      /**
       * @description Returns a list of questions based on the provided ids
       *
       * @tags questions
       * @name GetQuestionsByIds
       * @request GET:/questions/
       */
      getQuestionsByIds: (t, e = {}) => this.request({
        path: "/questions/",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Returns a list of questions in given educational material
       *
       * @tags questions
       * @name SearchQuestions
       * @request GET:/questions/search/{educationalMaterialId}
       */
      searchQuestions: (t, e, s = {}) => this.request({
        path: `/questions/search/${t}`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Upload media
       *
       * @tags questions
       * @name UploadQuestionMedia
       * @request POST:/questions/upload-media
       */
      uploadQuestionMedia: (t, e = {}) => this.request({
        path: "/questions/upload-media",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      }),
      /**
       * @description Delete question by id
       *
       * @tags questions
       * @name DeleteQuestion
       * @request DELETE:/questions/{id}
       */
      deleteQuestion: (t, e = {}) => this.request({
        path: `/questions/${t}`,
        method: "DELETE",
        ...e
      })
    });
    r(this, "results", {
      /**
       * @description Return educational materials that has exercises for user
       *
       * @tags results
       * @name GetEMsWithExercises
       * @request GET:/results/educational-materials
       */
      getEMsWithExercises: (t = {}) => this.request({
        path: "/results/educational-materials",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Return educational material with chapter structure
       *
       * @tags results
       * @name GetEmWithChapters
       * @request GET:/results/educational-materials/{id}
       */
      getEmWithChapters: (t, e = {}) => this.request({
        path: `/results/educational-materials/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Return all groups with educational material and students
       *
       * @tags results
       * @name GetGroupEms
       * @request GET:/results/groups/educational-materials
       */
      getGroupEms: (t = {}) => this.request({
        path: "/results/groups/educational-materials",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Return responses for users in a group for a specific educational material
       *
       * @tags results
       * @name GetResponsesForGroup
       * @request GET:/results/groups/{groupId}/educational-materials/{educationalMaterialId}/responses
       */
      getResponsesForGroup: (t, e, s = {}) => this.request({
        path: `/results/groups/${t}/educational-materials/${e}/responses`,
        method: "GET",
        format: "json",
        ...s
      }),
      /**
       * @description Get teacher comment for response
       *
       * @tags results
       * @name GetCommentByTeacher
       * @request GET:/results/responses/{id}/comment
       */
      getCommentByTeacher: (t, e = {}) => this.request({
        path: `/results/responses/${t}/comment`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Set response read by student
       *
       * @tags results
       * @name SetResponseReadByStudent
       * @request PUT:/results/student/responses/{id}
       */
      setResponseReadByStudent: (t, e, s = {}) => this.request({
        path: `/results/student/responses/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Return reviewed responses
       *
       * @tags results
       * @name GetReviewedResponsesForStudent
       * @request GET:/results/student/reviewed-responses
       */
      getReviewedResponsesForStudent: (t = {}) => this.request({
        path: "/results/student/reviewed-responses",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Get exercise metadata
       *
       * @tags results
       * @name GetExerciseMetaData
       * @request GET:/results/teacher/exercises/{id}
       */
      getExerciseMetaData: (t, e = {}) => this.request({
        path: `/results/teacher/exercises/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Get responses with answers
       *
       * @tags results
       * @name GetResponsesWithAnswers
       * @request GET:/results/teacher/exercises/{id}/responses
       */
      getResponsesWithAnswers: (t, e = {}) => this.request({
        path: `/results/teacher/exercises/${t}/responses`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns responses that needs reviewing
       *
       * @tags results
       * @name GetResponsesNeedsReviewing
       * @request GET:/results/teacher/needs-review
       */
      getResponsesNeedsReviewing: (t = {}) => this.request({
        path: "/results/teacher/needs-review",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Skip review of responses by teacher
       *
       * @tags results
       * @name SkipReviewResponsesTeacher
       * @request PUT:/results/teacher/responses/review
       */
      skipReviewResponsesTeacher: (t, e = {}) => this.request({
        path: "/results/teacher/responses/review",
        method: "PUT",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Add comment to response by teacher
       *
       * @tags results
       * @name AddCommentByTeacher
       * @request PUT:/results/teacher/responses/{id}/comment
       */
      addCommentByTeacher: (t, e, s = {}) => this.request({
        path: `/results/teacher/responses/${t}/comment`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Review response by teacher
       *
       * @tags results
       * @name ReviewResponseTeacher
       * @request PUT:/results/teacher/responses/{id}/review
       */
      reviewResponseTeacher: (t, e, s = {}) => this.request({
        path: `/results/teacher/responses/${t}/review`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Returns reviewed responses
       *
       * @tags results
       * @name GetResponsesReviewed
       * @request GET:/results/teacher/reviewed
       */
      getResponsesReviewed: (t, e = {}) => this.request({
        path: "/results/teacher/reviewed",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Return responses for user
       *
       * @tags results
       * @name GetResponsesForUser
       * @request GET:/results/users/{userId}/educational-materials/{educationalMaterialId}/responses
       */
      getResponsesForUser: (t, e, s = {}) => this.request({
        path: `/results/users/${t}/educational-materials/${e}/responses`,
        method: "GET",
        format: "json",
        ...s
      }),
      /**
       * @description Delete responses in an educational material
       *
       * @tags results
       * @name DeleteResponses
       * @request DELETE:/results/{userId}/{educationalMaterialId}
       */
      deleteResponses: (t, e, s = {}) => this.request({
        path: `/results/${t}/${e}`,
        method: "DELETE",
        ...s
      })
    });
    r(this, "samplePlans", {
      /**
       * @description Creates a sample plan
       *
       * @tags sample-plans
       * @name CreateSamplePlan
       * @request POST:/sample-plans/
       */
      createSamplePlan: (t, e = {}) => this.request({
        path: "/sample-plans/",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Copy a sample plan
       *
       * @tags sample-plans
       * @name CopySamplePlan
       * @request POST:/sample-plans/{id}/copy
       */
      copySamplePlan: (t, e, s = {}) => this.request({
        path: `/sample-plans/${t}/copy`,
        method: "POST",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Publish a sample plan
       *
       * @tags sample-plans
       * @name PublishSamplePlan
       * @request PUT:/sample-plans/{id}/publish
       */
      publishSamplePlan: (t, e = {}) => this.request({
        path: `/sample-plans/${t}/publish`,
        method: "PUT",
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Unpublish a sample plan
       *
       * @tags sample-plans
       * @name UnPublishSamplePlan
       * @request PUT:/sample-plans/{id}/unpublish
       */
      unPublishSamplePlan: (t, e = {}) => this.request({
        path: `/sample-plans/${t}/unpublish`,
        method: "PUT",
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "search", {
      /**
       * @description Returns search results with articles and media for a users licensed educational material
       *
       * @tags search
       * @name SearchEducationalMaterial
       * @request GET:/search
       */
      searchEducationalMaterial: (t, e = {}) => this.request({
        path: "/search",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Returns a list of searchable educational material (that are licensed to the users)
       *
       * @tags search
       * @name GetAvailableEducationalMaterials
       * @request GET:/search/available-educational-materials
       */
      getAvailableEducationalMaterials: (t = {}) => this.request({
        path: "/search/available-educational-materials",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * No description
       *
       * @tags search
       * @name IndexAllEducationalMaterials
       * @request POST:/search/index/all-educational-material
       */
      indexAllEducationalMaterials: (t = {}) => this.request({
        path: "/search/index/all-educational-material",
        method: "POST",
        type: "application/json",
        ...t
      }),
      /**
       * No description
       *
       * @tags search
       * @name DeleteArticlesFromIndex
       * @request POST:/search/index/delete-articles
       */
      deleteArticlesFromIndex: (t, e = {}) => this.request({
        path: "/search/index/delete-articles",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      /**
       * No description
       *
       * @tags search
       * @name IndexArticle
       * @request POST:/search/index/educational-material/{educationalMaterialSlug}/article/{articleId}
       */
      indexArticle: (t, e, s = {}) => this.request({
        path: `/search/index/educational-material/${t}/article/${e}`,
        method: "POST",
        type: "application/json",
        ...s
      }),
      /**
       * No description
       *
       * @tags search
       * @name IndexEducationalMaterial
       * @request POST:/search/index/educational-material/{slug}
       */
      indexEducationalMaterial: (t, e = {}) => this.request({
        path: `/search/index/educational-material/${t}`,
        method: "POST",
        type: "application/json",
        ...e
      }),
      /**
       * @description Search words
       *
       * @tags word
       * @name SearchWords
       * @request GET:/search/words
       */
      searchWords: (t, e = {}) => this.request({
        path: "/search/words",
        method: "GET",
        query: t,
        format: "json",
        ...e
      })
    });
    r(this, "shareMaterials", {
      /**
       * @description Returns a list of who teacher material is shared with
       *
       * @tags share-materials
       * @name GetSharedMaterialGroups
       * @request GET:/share-materials/{educationalMaterialId}/relations/{articleRelationsId}/groups
       */
      getSharedMaterialGroups: (t, e, s = {}) => this.request({
        path: `/share-materials/${t}/relations/${e}/groups`,
        method: "GET",
        format: "json",
        ...s
      }),
      /**
       * @description Updates share materials
       *
       * @tags share-materials
       * @name SaveSharedMaterialGroup
       * @request PUT:/share-materials/{educationalMaterialId}/relations/{articleRelationsId}/groups/{groupId}
       */
      saveSharedMaterialGroup: (t, e, s, i, n = {}) => this.request({
        path: `/share-materials/${t}/relations/${e}/groups/${s}`,
        method: "PUT",
        body: i,
        type: "application/json",
        ...n
      }),
      /**
       * @description Returns teacher toc for shared material
       *
       * @tags share-materials
       * @name GetSharedMaterialToc
       * @request GET:/share-materials/{educationalMaterialId}/toc
       */
      getSharedMaterialToc: (t, e = {}) => this.request({
        path: `/share-materials/${t}/toc`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "slideShows", {
      /**
       * @description Gets a slide show
       *
       * @tags slide-shows
       * @name GetViewSlideShow
       * @request GET:/slide-shows/{id}/
       */
      getViewSlideShow: (t, e = {}) => this.request({
        path: `/slide-shows/${t}/`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "support", {
      /**
       * @description Create a support case
       *
       * @tags support
       * @name CreateSupportCase
       * @request POST:/support
       */
      createSupportCase: (t, e = {}) => this.request({
        path: "/support",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      })
    });
    r(this, "unfurl", {
      /**
       * @description Unfurls an URL and returns extracted information
       *
       * @tags unfurl
       * @name Unfurl
       * @request POST:/unfurl
       */
      unfurl: (t, e = {}) => this.request({
        path: "/unfurl",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "user", {
      /**
       * @description Returns a list of unread alerts
       *
       * @tags user
       * @name GetAlerts
       * @request GET:/user/alerts
       */
      getAlerts: (t, e = {}) => this.request({
        path: "/user/alerts",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Deletes a alert aka mark as read
       *
       * @tags user
       * @name DeleteAlert
       * @request DELETE:/user/alerts/{id}
       */
      deleteAlert: (t, e = {}) => this.request({
        path: `/user/alerts/${t}`,
        method: "DELETE",
        type: "application/json",
        ...e
      }),
      /**
       * @description Returns a list of groups
       *
       * @tags user
       * @name GetGroups
       * @request GET:/user/educational-materials/{educationalMaterialId}/groups
       */
      getGroups: (t, e = {}) => this.request({
        path: `/user/educational-materials/${t}/groups`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns if a educational material is licensed
       *
       * @tags user
       * @name GetIsLicensed
       * @request GET:/user/educational-materials/{slug}/licensed
       */
      getIsLicensed: (t, e = {}) => this.request({
        path: `/user/educational-materials/${t}/licensed`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Returns news (global and educational material) for a user
       *
       * @tags marketing
       * @name GetUserNews
       * @request GET:/user/news
       */
      getUserNews: (t, e = {}) => this.request({
        path: "/user/news",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description Mark news as read or dismissed
       *
       * @tags marketing
       * @name UpdateNewsStatus
       * @request PUT:/user/news/{id}
       */
      updateNewsStatus: (t, e, s = {}) => this.request({
        path: `/user/news/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...s
      })
    });
    r(this, "wordLists", {
      /**
       * @description Creates a word list
       *
       * @tags word-lists
       * @name CreateWordList
       * @request POST:/word-lists
       */
      createWordList: (t, e = {}) => this.request({
        path: "/word-lists",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Deletes a list of word lists
       *
       * @tags word-lists
       * @name DeleteWordLists
       * @request DELETE:/word-lists
       */
      deleteWordLists: (t, e = {}) => this.request({
        path: "/word-lists",
        method: "DELETE",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Gets a word list with words
       *
       * @tags word-lists
       * @name GetWordList
       * @request GET:/word-lists/{id}
       */
      getWordList: (t, e = {}) => this.request({
        path: `/word-lists/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Edits a word list
       *
       * @tags word-lists
       * @name EditWordList
       * @request PUT:/word-lists/{id}
       */
      editWordList: (t, e, s = {}) => this.request({
        path: `/word-lists/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      })
    });
    r(this, "words", {
      /**
       * @description Edits a list of words
       *
       * @tags word
       * @name EditWords
       * @request PUT:/words
       */
      editWords: (t, e = {}) => this.request({
        path: "/words",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      /**
       * @description Creates a word
       *
       * @tags word
       * @name CreateWord
       * @request POST:/words
       */
      createWord: (t, e = {}) => this.request({
        path: "/words",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Deletes a list of words
       *
       * @tags word
       * @name DeleteWords
       * @request DELETE:/words
       */
      deleteWords: (t, e = {}) => this.request({
        path: "/words",
        method: "DELETE",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description get warning if word is used in lists
       *
       * @tags word
       * @name DeleteWordWarning
       * @request GET:/words/delete-warning
       */
      deleteWordWarning: (t, e = {}) => this.request({
        path: "/words/delete-warning",
        method: "GET",
        query: t,
        format: "json",
        ...e
      }),
      /**
       * @description lists educational materials with words connected
       *
       * @tags word
       * @name GetEducationalMaterialFilters
       * @request GET:/words/educational-material-filters
       */
      getEducationalMaterialFilters: (t = {}) => this.request({
        path: "/words/educational-material-filters",
        method: "GET",
        format: "json",
        ...t
      }),
      /**
       * @description Returns a list of chapters with articles and components
       *
       * @tags word
       * @name GetChapters
       * @request GET:/words/educational-materials/{id}/chapters
       */
      getChapters: (t, e = {}) => this.request({
        path: `/words/educational-materials/${t}/chapters`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Creates a file on S3 that contains a flashcard session to be retrieved by link
       *
       * @tags word
       * @name CreateFlashcardLink
       * @request POST:/words/flashcard-link
       */
      createFlashcardLink: (t, e = {}) => this.request({
        path: "/words/flashcard-link",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      /**
       * @description Retrieves words connected to a flash card link
       *
       * @tags word
       * @name GetFlashcardLink
       * @request GET:/words/flashcard-link/{id}
       */
      getFlashcardLink: (t, e = {}) => this.request({
        path: `/words/flashcard-link/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Retrieves the words to be trained during one flashcard session
       *
       * @tags word
       * @name FlashcardSession
       * @request GET:/words/flashcard-session/{educationalMaterialId}
       */
      flashcardSession: (t, e, s = {}) => this.request({
        path: `/words/flashcard-session/${t}`,
        method: "GET",
        query: e,
        format: "json",
        ...s
      }),
      /**
       * @description Returns info of supplied image
       *
       * @tags word
       * @name WordImageInfo
       * @request POST:/words/image/info
       */
      wordImageInfo: (t, e = {}) => this.request({
        path: "/words/image/info",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      }),
      /**
       * @description Returns a word
       *
       * @tags word
       * @name GetWord
       * @request GET:/words/{id}
       */
      getWord: (t, e = {}) => this.request({
        path: `/words/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      /**
       * @description Edits a word
       *
       * @tags word
       * @name EditWord
       * @request PUT:/words/{id}
       */
      editWord: (t, e, s = {}) => this.request({
        path: `/words/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Import words with excel file
       *
       * @tags word
       * @name ImportWordsToList
       * @request POST:/words/{id}/import
       */
      importWordsToList: (t, e, s = {}) => this.request({
        path: `/words/${t}/import`,
        method: "POST",
        body: e,
        type: "multipart/form-data",
        format: "json",
        ...s
      }),
      /**
       * @description Uploads files for word
       *
       * @tags word
       * @name UploadFiles
       * @request POST:/words/{wordId}/files
       */
      uploadFiles: (t, e, s = {}) => this.request({
        path: `/words/${t}/files`,
        method: "POST",
        body: e,
        type: "multipart/form-data",
        format: "json",
        ...s
      }),
      /**
       * @description Recalculated spaced repetition data for a word and user
       *
       * @tags word
       * @name UpsertSpacedRepetitionData
       * @request PUT:/words/{wordId}/spaced-repetition
       */
      upsertSpacedRepetitionData: (t, e, s = {}) => this.request({
        path: `/words/${t}/spaced-repetition`,
        method: "PUT",
        body: e,
        type: "application/json",
        format: "json",
        ...s
      })
    });
  }
}
const L = (o) => {
  const a = async (...t) => {
    const e = g(t[0]), s = t[1], i = { ...s == null ? void 0 : s.headers, ...o == null ? void 0 : o.headers }, n = await fetch(e, {
      ...s,
      headers: i
    });
    return b(n, o), n;
  };
  return new k({ customFetch: a });
}, W = L({});
export {
  k as Api,
  f as ApiFetchError,
  D as ContentType,
  U as HttpClient,
  M as LanguageCode,
  W as apiBackend,
  R as apiClient,
  A as apiFetch,
  L as configApiBackend,
  F as registerRedirectObserver,
  I as unregisterRedirectObserver
};
//# sourceMappingURL=index.js.map
